import { toDateString } from '@/utils/date';

/** The part of an overview location the bioscope counts read. */
interface MeasuredLocation {
    cages?: Array<{ activeBioscopes: number[]; cageData: { weight?: { day: string } } }>;
}

/** Pens across the locations whose latest weight measurement is from today. */
export const amountOfActiveBioscopes = (locations: MeasuredLocation[]): number => {
    let amount = 0;
    for (const location of locations) {
        for (const cage of location?.cages || []) {
            const weightDay = cage.cageData.weight?.day;
            if (weightDay !== undefined && toDateString(weightDay) === toDateString(new Date())) {
                amount++;
            }
        }
    }
    return amount;
};

/** Bioscopes across the locations' pens, measuring or not. */
export const totalAmountOfActiveBioscopes = (locations: MeasuredLocation[]): number => {
    let amount = 0;

    for (const location of locations) {
        for (const cage of location?.cages || []) {
            amount += cage?.activeBioscopes.length;
        }
    }

    return amount;
};
